import { apiAnalytics } from '@api/analytics';

// Snippet of code is responsible for replacing the default "Submit" text in
// the footer form and replacing it with an SVG.
// May want to see if there's a better way to do this once work slows down
document.addEventListener('DOMContentLoaded', () => {
  const footerForm = document.querySelector('form[id^="fui-footerForm-"]');
  if (!footerForm) return;

  const submitBtn = footerForm.querySelector('button[type="submit"]');
  if (submitBtn) {
    submitBtn.innerHTML = `
      <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 8.64307H18M18 8.64307L11.7097 0.536407M18 8.64307L11.7097 16.5364" stroke="currentColor" stroke-width="1.75"/>
      </svg>`;
  }

  // Anonymous email opt-in: fire an identify call with the submitted email.
  // Routed through server-side SQS pipeline to RudderStack.
  footerForm.addEventListener('onAfterFormieSubmit', () => {
    const emailInput = footerForm.querySelector<HTMLInputElement>('input[type="email"]');
    const email = emailInput?.value?.trim();
    if (email) {
      // Server-side: Craft → RudderStack SQS → Lambda → RudderStack HTTP API
      apiAnalytics.identify({ email }).catch(() => {});
    }
  });
});
